import Dialog from "../utils/Dialog";

class SpektrixIframe {
    constructor(element) {
        this.element = element;
        this.iframe = element.querySelector("iframe");
        this.uid = this.iframe.dataset.iframeUid;
        this.loadingIndicator = element.querySelector(
            ".spektrix-iframe__loading-indicator",
        );

        this.iframe.addEventListener("load", () => {
            this.loaded();
        });

        if (this.iframe.readyState === "complete") {
            this.loaded();
        }
    }

    loaded() {
        this.loadingIndicator &&
            this.loadingIndicator.setAttribute("active", false);
        this.iframe.classList.add("is-loaded");
    }
}

// Parent-side iframe resize is handled by cog-wp-spektrix's cog-integrate.js
// (enqueued as `wp-spektrix-resize`). See infra/wp/plugins/cog-wp-spektrix/
// Wordpress/public/js/cog-integrate.js — that file owns the resize message
// listener; a logic bug there was clipping buy-buttons intermittently
// (fixed 2026-05-09).

// window.spekShowViewFromSeat = function (url, tooltip) {
//     // console.log(url, tooltip);

//     const dialogEl = document.querySelector(".view-from-seat-dialog");

//     const dialog = new Dialog(dialogEl);

//     const image = document.createElement("img");
//     image.src = url;

//     // dialog.content = image;

//     dialog.contentSlot.innerHTML = image.outerHTML;

//     dialog.open();
// };

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".spektrix-iframe").forEach((element) => {
        new SpektrixIframe(element);
    });
});
